import * as React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./Ops.CardLoads.List";
import Summary from "./Ops.CardLoads.Summary";
import Payment from "./Ops.CardLoads.Payment";

const CardLoads = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/card_loads"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/card_loads/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/card_loads/:id/payment"
      render={routerProps => <Payment {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default CardLoads;
